import { useState } from "react";
import { ListItem } from "../../../__shared__/ListItem/ListItem";
import styles from "./Badges.module.scss";
import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";
import cx from "classnames";
import { GoodToKnowDrawer } from "./GoodToKnowDrawer/GoodToKnowDrawer";
import { CleanBeautyLabels } from "../../../../hooks/useCleanBeauty/cleanBeautySchema";
import badgesTexts from "./badgesText.json";
import { sendEvent } from "@JohnLewisPartnership/experiments-utils";

type BadgesProps = {
  labels: CleanBeautyLabels[];
  goodToKnowObservation: boolean;
};

const classNames = cx(styles.list, styles.badge);

function transformIngredientText(badges: string) {
  return badges
    .replace(/_/, " ")
    .split(" ")
    .map(
      (word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase(),
    )
    .join(" ");
}

export const Badges = ({
  labels: badges,
  goodToKnowObservation,
}: BadgesProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [header, setHeader] = useState<string>("");
  const [description, setDescription] = useState<string[]>([]);

  const handleOpenDrawer = (badge: CleanBeautyLabels) => {
    setHeader(transformIngredientText(badge));
    setDescription(badgesTexts[badge]);
    if (goodToKnowObservation) {
      sendEvent("GoodToKnowDrawerOpen");
    }
    setIsOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsOpen(false);
  };
  return (
    <div className={styles.badges}>
      <GoodToKnowDrawer
        isOpen={isOpen}
        handleClose={handleCloseDrawer}
        badgeHeader={header}
        description={description}
      ></GoodToKnowDrawer>
      {badges.map((badge, index) => (
        <ListItem
          key={index}
          trailingIcon={<ArrowRight data-testid={"badgelabels-arrow"} />}
          label={transformIngredientText(badge)}
          onClick={() => {
            handleOpenDrawer(badge);
          }}
          className={classNames}
        />
      ))}
    </div>
  );
};
